export function generateOptions(first: number, last: number): number[] {
  const options = [];
  for (let i = first; i <= last; i += 1) {
    options.push(i);
  }
  return options;
}
